import React from "react";

export default function CSS_Bootcamp() {
  return (
    <div className="tutorial-page">
      <h1>CSS Bootcamp</h1>
      <p>This is the CSS Bootcamp tutorial page.</p>
    </div>
  );
}
